module.exports = __webpack_public_path__ + "static/media/nonPayable.879da4f1.svg";